__turbopack_context__.v({
  "arrive": "landing-module__39-Plq__arrive",
  "fade": "landing-module__39-Plq__fade",
  "full": "landing-module__39-Plq__full",
  "prose": "landing-module__39-Plq__prose",
  "proseLg": "landing-module__39-Plq__proseLg",
  "shimmer": "landing-module__39-Plq__shimmer",
  "tableWrap": "landing-module__39-Plq__tableWrap",
  "tl-arrive": "landing-module__39-Plq__tl-arrive",
  "tl-shimmer": "landing-module__39-Plq__tl-shimmer",
});
